import type { ReactNode } from "react";
import { OHNE_ANTWORT } from "../plattform/api";
import { Symbol } from "./Symbol";

/**
 * Feste Wortlaute (oberflaeche.md §9): Hinweise als `status`, Meldungen als `alert`. Der Text steht als ganzer
 * Textinhalt im Element, damit die Suite ihn exakt findet. Gestaltung als ruhige Platte ohne Kachelfläche
 * (design/README §1 Nr. 10, `hinweis090`): nur Bedienbares sieht aus wie eine Kachel. Eine Handlung zum Hinweis
 * (z. B. „Anleitung“) steht im selben `status`.
 */
export function Status({ children, symbol, aktion }: { children: ReactNode; symbol?: string; aktion?: ReactNode }) {
  return (
    <div className={`hinweis090 platte hinweistext${aktion ? " hinweistext--aktion" : ""}`} role="status">
      {symbol ? <Symbol name={symbol} /> : null}
      <span className="hinweistext__t">{children}</span>
      {aktion}
    </div>
  );
}

export function Meldung({ children, symbol = "abgewiesen" }: { children: ReactNode; symbol?: string }) {
  return (
    <div className="hinweis090 platte hinweistext hinweistext--meldung" role="alert">
      <Symbol name={symbol} />
      <span className="hinweistext__t">{children}</span>
    </div>
  );
}

/** Feste Meldung, wenn der Dienst nicht verwertbar geantwortet hat (oberflaeche.md §9). */
export const WORTLAUT_KEINE_VERBINDUNG = "Keine Verbindung. Bitte mit Netz noch einmal versuchen.";

/**
 * Abweisung einer Handlung: der Grund wörtlich nach dem Text „abgewiesen“ (oberflaeche.md §9); ohne verwertbare Antwort
 * des Dienstes (`OHNE_ANTWORT`, `plattform/api.ts`) die feste Meldung „Keine Verbindung. …“ — keine Abweisung bleibt
 * stumm (Anforderungen K106 (2)).
 */
export function Abweisung({ grund }: { grund: string | null }) {
  if (!grund) return null;
  if (grund === OHNE_ANTWORT) return <Meldung symbol="offline">{WORTLAUT_KEINE_VERBINDUNG}</Meldung>;
  return <Meldung symbol="abgewiesen">abgewiesen <span className="grund kennung">{grund}</span></Meldung>;
}

/**
 * Schutzfläche mit Inhalt (design/README §14, Review 0f O-f2, Referenz `info()`): füllt einen freien Platz, der aus
 * Gründen der Doppeltipp-Geometrie frei bleiben muss; der Inhalt erscheint nur, wenn er ganz hineinpasst (`gross` ab
 * 9,5 rem Höhe). Nichts darin ist bedienbar.
 */
export function Schutzflaeche({ zeilen, gross, className }: { zeilen: ReactNode[]; gross?: boolean; className?: string }) {
  return (
    <div className={["info-flaeche", gross ? "info-flaeche--gross" : null, className].filter(Boolean).join(" ")}>
      <div className="info platte">{zeilen.map((z, i) => <p key={i}>{z}</p>)}</div>
    </div>
  );
}
